import React, { useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import NumberFormat from "react-number-format"
import { connect } from "react-redux"
import { getSaleHistory } from "../../../../actions/productAction"

/* ASSETS */
import averageSaleIcon from "../../../../images/graph-average.png"
import lowestSaleIcon from "../../../../images/graph-lowest.png"
import pricePremiumIcon from "../../../../images/graph-price-premium.png"
import highestSaleIcon from "../../../../images/graph-highest.png"

function Table({ productData, getSaleHistory, saleHistory }) {
  const { id } = productData
  const [averageSale, setAverageSale] = useState(0);
  const [premiumPrice, setPremiumPrice] = useState(0);
  const [lowestSale, setLowestSale] = useState(0);
  const [highestSale, setHighestSale] = useState(0);
  const [showTable, setShowTable] = useState(false);

  useEffect(() => {
    id && getSaleHistory(id, "brandnew", "all")
      .then(data => {
        const salesData = data.action.payload.data[`${id}`][0]
        setAverageSale(salesData.average_price)
        setPremiumPrice(Number(salesData.price_premium))
        setLowestSale(salesData.lowest_price)
        setHighestSale(salesData.highest_price)
      })
      .catch(e => null)
  }, [productData]);

  return (
    <div id="sales-table-container">
      {averageSale && lowestSale && highestSale ? (
        <>
          <div className="icon-wrapper average-sale-table">
            <KickImage src={averageSaleIcon} />
            <div className="text">
              <NumberFormat value={averageSale} displayType={"text"} thousandSeparator={true} prefix={"IDR. "} />
              <p>Average Sale</p>
            </div>
          </div>
          <div className="icon-wrapper premium-price-table">
            <KickImage src={pricePremiumIcon} />
            <div className="text">
              <NumberFormat value={premiumPrice} displayType={"text"} thousandSeparator={true} suffix={"%"} />
              <p>Price Premium</p>
            </div>
          </div>
          <div className="icon-wrapper lowest-sale-table">
            <KickImage src={lowestSaleIcon} />
            <div className="text">
              <NumberFormat value={lowestSale} displayType={"text"} thousandSeparator={true} prefix={"IDR. "} />
              <p>Lowest Sale</p>
            </div>
          </div>
          <div className="icon-wrapper highest-sale-table">
            <KickImage src={highestSaleIcon} />
            <div className="text">
              <NumberFormat value={highestSale} displayType={"text"} thousandSeparator={true} prefix={"IDR. "} />
              <p>Highest Sale</p>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => ({
  saleHistory: state.dataProduct.saleHistory.data,
});
const mapDispatchToProps = {
  getSaleHistory
}
export default connect(mapStateToProps, mapDispatchToProps)(Table)